import { useLang, useContent, loc, UI } from "@/lib/content";
import { LogoLockup } from "./LogoMark";

export default function Footer() {
  const { content } = useContent();
  const { lang } = useLang();
  return (
    <footer className="border-t border-linelight bg-navydeep py-14 text-paper/60">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="flex flex-col items-start justify-between gap-10 md:flex-row md:items-center">
          <div>
            <LogoLockup light brand={content.brand_name} suffix={loc(content.brand_suffix, lang)} />
            <p className="mt-4 max-w-sm text-sm leading-relaxed">{loc(UI.footer.tagline, lang)}</p>
          </div>
          <div className="flex flex-col gap-2.5 text-sm">
            <span className="font-mono text-[10px] font-semibold uppercase tracking-[0.22em] text-brass">{loc(UI.footer.explore, lang)}</span>
            {UI.footer.exploreLinks.map((l, i) => (
              <a key={l.href} href={l.href} data-testid={`footer-link-${i}`} className="transition-colors hover:text-paper">
                {loc(l.label, lang)}
              </a>
            ))}
          </div>
        </div>
        <div className="mt-12 flex flex-col gap-3 border-t border-linelight pt-6 text-xs md:flex-row md:items-center md:justify-between">
          <p>© {new Date().getFullYear()} {content.brand_name}. {loc(UI.footer.rights, lang)}</p>
          <p className="max-w-xl leading-relaxed">{loc(UI.footer.disclaimer, lang)}</p>
          <a href="/admin" data-testid="footer-admin-link" className="text-paper/40 transition-colors hover:text-brass">
            {loc(UI.footer.admin, lang)}
          </a>
        </div>
      </div>
    </footer>
  );
}
